export const GET_PLAZAS_JEFES = 'GET_PLAZAS_JEFES';
export const LOADING_PLAZAS_JEFES = 'LOADING_PLAZAS_JEFES';




